import React from "react"

const LONG_PRESS_MS = 500

// Renders a single line item row inside an OrderCard. The action button is
// generic: in the default (bump) mode it advances kds state on tap, bumps
// all units on long-press; in recall mode the same gestures pull the item
// back to the active grid.
class ItemRow extends React.PureComponent {
  static defaultProps = {
    actionLabel: "Complete",
    actionTitle: "Tap to complete 1 · Hold to complete all",
    actionClassName: "is-success",
  }

  pressTimer = null

  startPress = () => {
    this.pressTimer = setTimeout(() => {
      this.pressTimer = null
      this.props.onActionAll(this.props.item)
    }, LONG_PRESS_MS)
  }

  endPress = () => {
    if (this.pressTimer) {
      clearTimeout(this.pressTimer)
      this.pressTimer = null
      this.props.onAction(this.props.item)
    }
  }

  cancelPress = () => {
    if (this.pressTimer) {
      clearTimeout(this.pressTimer)
      this.pressTimer = null
    }
  }

  render() {
    const { item, actionLabel, actionTitle, actionClassName } = this.props
    const stateClass = item.kdsState || ""
    const outstanding = item.outstandingQuantity ?? item.quantity

    return (
      <div className={`ItemRow ${stateClass}`}>
        <span className="qty">{outstanding}×</span>
        <div className="body">
          <div className="name">{item.name}</div>
          {item.modifiers && item.modifiers.length > 0 && (
            <div className="modifiers">{item.modifiers.map((m) => m.name).join(" · ")}</div>
          )}
          {item.notes && <div className="notes">"{item.notes}"</div>}
        </div>
        <button
          className={`button h-button ${actionClassName} is-small`}
          onMouseDown={this.startPress}
          onMouseUp={this.endPress}
          onMouseLeave={this.cancelPress}
          onTouchStart={this.startPress}
          onTouchEnd={this.endPress}
          onTouchCancel={this.cancelPress}
          title={actionTitle}
        >
          {actionLabel}
        </button>
      </div>
    )
  }
}

export default ItemRow
